import { useCircleV4 } from "@circle-react/hooks/useCircleV4";

import { ProfileHoverCard as ProfileHoverCardCompass } from "./HoverCard";
import type { ProfileHoverCardProps } from "./HoverCard";
import { ProfileHoverCard as ProfileHoverCardUiKit } from "./HoverCardUiKit";

export const ProfileHoverCard = (props: ProfileHoverCardProps) => {
  const { isCircleV4 } = useCircleV4();
  return isCircleV4 ? (
    <ProfileHoverCardCompass {...props} />
  ) : (
    <ProfileHoverCardUiKit {...props} />
  );
};
